import { useMediaQuery } from "./useMediaQuery";

const BREAKPOINTS = {
  sm: 640,
  lg: 1024,
} as const;

export type Breakpoints = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

export function useBreakpoints(): Breakpoints {
  const sm = useMediaQuery(`(min-width: ${BREAKPOINTS.sm}px)`);
  const lg = useMediaQuery(`(min-width: ${BREAKPOINTS.lg}px)`);

  return {
    isMobile: !sm,
    isTablet: sm && !lg,
    isDesktop: lg,
  };
}
